import SlotItemContainer from './SlotItemContainer';

export default SlotItemContainer;
